const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

import { hmin, hrs } from "./time";

export const fmtH = hrs;
export const hm = hmin;
export const REF_MIN = 35 * 60;
export const refPct = (m) => Math.min(100, (m / REF_MIN) * 100);
export const pct = (x) => `${Math.round(x * 100)}%`;
export const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
export const flagged = (c) => c.minutes > 0 && Math.round((c.revisionMinutes / c.minutes) * 100) > 30;
export const monthName = (m) => MONTHS[Number(m.slice(5, 7)) - 1];
export const monthShort = (m) => monthName(m).slice(0, 3);
export const nextMonthStart = (m) => `1 ${MONTHS[Number(m.slice(5, 7)) % 12]}`;
export const az = (a, b) => (a.toLowerCase() < b.toLowerCase() ? -1 : a.toLowerCase() > b.toLowerCase() ? 1 : 0);
export const GROUPS = ["design", "video", "other"];
export const GROUP_LABEL = { design: "Design", video: "Video", other: "Other teams" };
export const TEAM_NAME = { servicing: "Client servicing", social: "Social media", events: "Events", accounts: "Accounts", management: "Management", ai: "AI & strategy" };
export const groupOf = (team) => (team === "design" || team === "video" ? team : "other");

export function prevMonths(m) {
  const [y, mo] = m.split("-").map(Number);
  return [2, 1, 0].map((k) => new Date(Date.UTC(y, mo - 1 - k, 1)).toISOString().slice(0, 7));
}

export function GroupLabel({ g, hours, className = "" }) {
  return <span className={`glabel g-${g} ${className}`} data-team={g === "other" ? undefined : g}>{GROUP_LABEL[g]}{hours != null && <span className="num"> {fmtH(hours)}</span>}</span>;
}

export function SplitBar({ c, h = 8 }) {
  const parts = [["design", c.designMinutes], ["video", c.videoMinutes], ["other", c.otherMinutes]].filter(([, m]) => m > 0);
  const label = `${hm(c.minutes)}: ${parts.map(([g, m]) => `${GROUP_LABEL[g]} ${hm(m)}`).join(", ")}`;
  return (
    <div className="sbar" role="img" aria-label={label} style={{ height: h }}>
      <div className="sbar-in" style={{ width: `${refPct(c.minutes)}%` }}>
        {parts.map(([g, m]) => <i key={g} className={`sb-${g}`} style={{ flexGrow: m }} />)}
      </div>
    </div>
  );
}
